import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getProfileOwnerStats } from '../../../selectors/users';
import { Props } from './Stats';

type StateProps = Pick<Props, 'stats'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  stats: getProfileOwnerStats(state),
});

export default connect(mapStateToProps);
